import React from "react";

const LandingPage = ({ history }) => {
  return (
    <div>
      <div>
        <div className="ui vertical masthead center aligned segment">
          <div className="ui text container">
            <h1 className="ui stackable header">
              {/* <img
                className="ui image massive"
                src="/assets/logo.png"
                alt="logo"
              /> */}
              <div className="content">Assess</div>
            </h1>
            <h2>Take as much test as you want</h2>
            <div
              style={{
                background: '#add8e6'
              }}
              onClick={() => history.push("/category")}
              className="ui huge white  button"
            >
              Get Started
              <i className="right arrow icon" />
            </div>
          </div>
        </div>
        <div style={{ textAlign: "center", alignItem: "center" }}>
          {/* Icons made by{" "}
          <a href="http://www.freepik.com" title="Freepik">
            Freepik
          </a>{" "}
          from{" "}
          <a href="https://www.flaticon.com/" title="Flaticon">
            www.flaticon.com
          </a>{" "}
          is licensed by{" "}
          <a
            href="http://creativecommons.org/licenses/by/3.0/"
            title="Creative Commons BY 3.0"
          >
            CC 3.0 BY
          </a> */}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
